import React from "react";

export const Privacy = () => {
  return (
    <section className="privacy">
      ​تحرص الأمانة العامة للجان الزكوية والضريبية والجمركية ("الأمانة العامة")
      على خصوصية وسرية المعلومات والبيانات الشخصية لمستخدمي الموقع الإلكتروني
      الخاص بها ("الموقع") والمنصات الرقمية وتطبيقات الهواتف الذكية التابعة لها
      وتضعها على رأس قائمة الأولويات، يهدف إشعار الخصوصية إلى مساعدتك على فهم
      نوع المعلومات التي نقوم بجمعها، وسبب جمعنا لها، وكيفية معالجتنا، وتعاملنا
      مع هذه المعلومات، ويعتبر إشعار الخصوصية جزء لا يتجزأ من شروط وأحكام
      استخدام الموقع الإلكتروني للأمانة العامة.
      <br />
      وباستخدامك خدمات الأمانة العامة أو الموقع أو تطبيقات الهواتف الذكية
      التابعة لها، فإنك تقر على الموافقة على سياسة الخصوصية لموقع الأمانة العامة
      للجان الزكوية والضريبية والجمركية.
      <br />
      <h2>
        المعلومات التي تجمعها الأمانة العامة للجان الزكوية والضريبية والجمركية
      </h2>
      تقوم الأمانة العامة بجمع أنواع مختلفة من المعلومات والبيانات الشخصية لزوار
      ومستخدمي الخدمات والمنصات والتطبيقات التابعة لها، وهي بشكل أساسي تتمثل
      فيما يلي:
      <br />
      - المعلومات التي تقوم بتزويد الأمانة العامة بها والمطلوبة عند الاستفادة من
      الخدمات أو التسجيل بالمنصات والتطبيقات التابعة للأمانة العامة أو التي
      تقدمها للأمانة العامة عند إنشائك لملف المستخدم الخاص بك، بما في ذلك
      البيانات الشخصية الخاصة بك أو لأحد أفراد أسرتك – على سبيل المثال لا الحصر
      - الاسم، رقم الهوية الشخصية، العنوان، أرقام التواصل، البريد الإلكتروني،
      أرقام التواصل، وأرقام الرُّخص والسجلات والممتلكات الشخصية، وأرقام الحسابات
      البنكية والبطاقات الائتمانية، وصور الفرد الثابتة أو المتحركة، وغير ذلك من
      البيانات ذات الطابع الشخصي.
      <br />
      - المعلومات المُتبادلة من خلال تواصل الأمانة العامة مع المستفيدين من
      الخدمات، مثل طلبات المقدمة لخدمات دعم العملاء، والاستفسارات، والملاحظات،
      والشكاوى المُستلمة منك.
      <br />
      - بيانات ملفات تعريف الارتباط (الكوكيز)، مثل البيانات التي يتم جمعها عن
      طريق سجلات مواقع الويب أو التقنيات أو ملفات الارتباط أو التقنيات المشابهة.
      <br />
      - عنوان بروتوكول الإنترنت الخاص بك (IP) وتفاصيل إصدار متصفح الويب الذي
      استخدمته.
      <br />
      - المعلومات التي تتلقاها الأمانة العامة من مصادر أخرى، يجوز للأمانة العامة
      أن تتلقى معلومات عنك في حال استخدامك لأي من المواقع الأخرى التي يتم
      تشغيلها من قِبل الأمانة العامة، أو أي من الخدمات الأخرى التي تقدمها، كما
      تعمل الأمانة العامة بشكل وثيق مع جهات أخرى ومنها على سبيل المثال: الجهات
      الحكومية، وأي جهات أخرى قد تزود الأمانة العامة بمعلومات خاصة بك.
      <br />
      <h2>طرق جمع المعلومات</h2>
      - يتم جمع المعلومات والبيانات الشخصية مباشرة عبر المعلومات والبيانات التي
      يقوم المستخدم بتزويد الأمانة العامة بها.
      <br />
      - قد تتلقى الأمانة العامة بيانات من مصادر أخرى في حال استخدامك أيًّا من
      المواقع أو الخدمات الأخرى التي يتم تشغيلها من قِبل الأمانة العامة، كما
      تعمل الأمانة العامة بشكل وثيق مع جهات أخرى، ومنها على سبيل المثال: الجهات
      الحكومية، وأي جهات أخرى قد تزود الأمانة العامة بمعلومات خاصة بك.
      <br />
      تقوم الأمانة العامة بجمع المعلومات الخاصة بمستخدمي الموقع الإلكتروني الخاص
      بها عبر طرق متعددة، فبمجرد زيارة الموقع الإلكتروني للأمانة العامة، يقوم
      الخادم الخاص بالأمانة العامة بتسجيل عنوان بروتوكول شبكة الإنترنت (IP)
      الخاص بالمستخدم، وتاريخ ووقت الزيارة، وعنوان (URL) الخاص بأي موقع إلكتروني
      يُحيلك إلى موقع الأمانة العامة، ويتم أيضًا جمع المعلومات والبيانات الشخصية
      بشكل مباشر عبر المعلومات والبيانات التي يقوم مستخدم الموقع بتزويدها
      للأمانة العامة.
      <br />
      <h2>ملفات تعريف الارتباط (الكوكيز)</h2>
      يستخدم موقع الأمانة العامة وبعض أو كل المنصات التابعة له ملفات تعريف
      الارتباط من أجل التمييز بينك وبين المستخدمين الآخرين ، وهذا يساعدنا على
      تزويدك بتجربة مميزة عند زيارتك لموقعنا، كما يساعدنا على تطوير الموقع،
      وباستمرار تصفحك للموقع؛ أنت توافق على قيام الأمانة العامة باستخدام ملفات
      تعريف الارتباط، ويمكنك حظر ملفات تعريف الارتباط من خلال تفعيل خاصية رفض كل
      هذه الملفات أو بعضها من إعدادات المتصفح الخاصة بك، ومع تفعيلك لحظر استخدام
      جميع ملفات تعريف الارتباط (بما في ذلك الملفات الأساسية) قد يتعذر وصولك إلى
      جميع أو بعض أجزاء الموقع.
      <br />
      <h2>الغرض من جمع المعلومات واستخدامها</h2>
      تقوم الأمانة العامة بجمع البيانات الشخصية واستخدامها لعدة أغراض بما يتوافق
      مع الأنظمة واللوائح والتعليمات ذات العلاقة، منها على سبيل المثال لا الحصر:
      <br />
      - تحسين إدارة الخدمات المتاحة.
      <br />
      - تحقيق الغرض الأساس الذي من أجله قام المستخدم بتزويد الأمانة العامة
      بالمعلومات والبيانات، كالحصول على خدمة معينة، أو الرد على الطلبات، أو
      الاستفسارات، أو الشكاوى.
      <br />
      - رصد وكشف انتهاكات شروط الاستخدام إلى جانب الإساءات الأخرى والمحتملة عند
      استخدام الموقع.
      <br />
      - الحفاظ على تحسين أداء الموقع، وأمان برمجياته، وأنظمته، وشبكته.
      <br />
      - إرسال المواد التوعوية المناسبة، ويمكنك طلب إلغاء إرسال المواد التوعوية
      بالتواصل مع الأمانة العامة. <br />
      <h2>مشاركة المعلومات والإفصاح عنها</h2>
      يحق للأمانة العامة مشاركة المعلومات والبيانات الشخصية التي تم تقديمها من
      قبلك أو جمعت عنك في الحالات التالية: <br />
      - إذا وجب على الأمانة العامة الإفصاح عن معلوماتك وبياناتك الشخصية أو
      مشاركتها من أجل التقيد بأي التزام نظامي أو تنفيذًا لشروط الاستخدام التابعة
      للأمانة العامة أو تطبيقها وغير ذلك من الاتفاقيات، أو من أجل حماية حقوق
      الأمانة العامة وملكياتها وسلامتها وسلامة منسوبيها أو غيرهم.
      <br />
      - قد تتم مشاركة المعلومات والبيانات الشخصية الخاصة بك أو الإفصاح عنها
      لأغراض البحث مع إحدى جهات المعالجة، ومع ذلك فإن الأمانة العامة سوف تشارك
      فقط المعلومات والبيانات الشخصية الخاصة بك لهذا الغرض بما يتوافق مع أحكام
      الأنظمة واللوائح المعمول بها، ويقتصر على المعلومات الشخصية المطلوبة لتحقيق
      الأغراض المذكورة عند وقت جمع تلك المعلومات والبيانات، وتحرص الأمانة العامة
      في اختيار جهات ملتزمة بالأنظمة واللوائح المعمول بها في المملكة، وتعمل
      بصورة مستمرة للتحقق من ذلك.
      <br />
      - قد يتم مشاركة المعلومات والبيانات الشخصية أو الإفصاح عنها استجابة
      لمذكرات الاستدعاء أو أوامر المحكمة أو أي إجراء قانوني آخر أو من أجل تحقيق
      أو منع أو اتخاذ إجراءات تتعلق بالممارسات غير القانونية أو حالات الاحتيال
      المشبوهة أو المشاكل التقنية أو الأمنية.
      <br />
      - وقد تتم مشاركة البيانات، إذا تم تجميعها من مصدر متاح للعموم أو بموافقة
      خطية من صاحبها وفقاً للأحكام المعمول بها أو للضرورة القصوى للمصلحة العامة
      أو مصلحة صاحبها أو تم التخلص من كل البيانات الشخصية التي يمكن أن تستخدم
      للاستدلال على صاحبها.​
      <br />
      <h2>حفظ المعلومات وإتلافها</h2>
      تقوم الأمانة العامة للجان الزكوية والضريبية والجمركية بتخزين معلوماتك
      وبياناتك الشخصية بأمان وذلك في مقر الأمانة العامة داخل المملكة أو من خلال
      حلول آمنة في خدمات الحوسبة السحابية، ويتم الاحتفاظ بالبيانات حتى انتهاء
      الغرض من معالجتها، بعد ذلك يتم إتلافها بطريقة آمنة تمنع التسرب أو الفقدان
      أو الاختلاس أو إساءة الاستخدام أو الوصول غير المصرح به نظامًا.
      <br />
      <h2>الأنظمة والسياسات ذات العلاقة</h2>
      تخضع هذه السياسة للأنظمة واللوائح والسياسات ذات العلاقة المعمول بها في
      المملكة.
      <br />
      <h2>
        حقوق صاحب البيانات التي يتم منحها وفق الأنظمة واللوائح والسياسات ذات
        العلاقة، ومن ذلك:
      </h2>
      - حق العلم، ويشمل ذلك إحاطته علمًا بالمسوغ النظامي لجمع بياناته الشخصية
      والغرض من جمعها.
      <br />
      - حق وصوله إلى بياناته الشخصية المتوافرة لدى جهة التحكم، وفق الضوابط
      والإجراءات التي يتم تحديدها.
      <br />
      - حق طلب الحصول على بياناته الشخصية المتوافرة لدى الأمانة العامة بصيغة
      مقروءة وواضحة، وفق الضوابط والإجراءات التي يتم تحديدها.
      <br />
      - حق طلب تصحيح بياناته الشخصية المتوافرة لدى الأمانة العامة، أو إتمامها،
      أو تحديثها.
      <br />
      - حق طلب إتلاف بياناته الشخصية المتوافرة لدى الأمانة العامة مما انتهت
      الحاجة إليه منها، وذلك دون إخلال بما ورد في أحكام النظام.
      <br />
      <h2>إخلاء المسؤولية</h2>
      هذه المنصة والخدمات المقدمة من الأمانة العامة للجان الزكوية والضريبية
      والجمركية السعودية متاحة لاستخدامك الشخصي، ويخضع دخولك واستخدامك لهذه
      الخدمة للبنود الواردة في إشعار الخصوصية ولأنظمة المملكة العربية السعودية.
      وكذلك يعد وصولك واستفادتك من هذه الخدمة والمنصة موافقة دون قيد أو شرط على
      بنود هذا الإشعار. وتسري هذه الموافقة بدءًا من تاريخ أول استخدام لك.
      <br />
      <h2>التغييرات في إشعار الخصوصية</h2>
      يحق للأمانة العامة تعديل وتحديث هذا الإشعار، ويستوجب عليك التحقق بشكل دوري
      من التحديثات ومراجعتها والتعرف عليها.
      <br />
      <h2>الروابط الخاصة بمواقع أخرى</h2>
      قد يحتوي الموقع الإلكتروني الخاص بالأمانة العامة والمنصات والتطبيقات
      التابعة لها من وقت لآخر على روابط من وإلى مواقع أخرى قد لا تكون تابعة
      للأمانة العامة، إذا اتبعت أي من هذه الروابط للوصول إلى هذه المواقع يتوجب
      عليك الاطلاع على إشعارات الخصوصية بتلك المواقع التي يتم الدخول إليها من
      خلال أي رابط ضمن الموقع الإلكتروني للأمانة العامة، ولا تعتبر الأمانة
      العامة - بأي حال من الأحوال- مسؤولة عن أساليب جمع وحماية البيانات من قبل
      تلك المواقع.
      <br />
      <h2>التغييرات التي قد تطرأ على سياسة الخصوصية</h2>
      للأمانة العامة للجان الزكوية والضريبية والجمركية حرية التصرف في تحديث
      سياسة الخصوصية هذه في أي وقت.
      <br />
    </section>
  );
};
